import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AgoraConfigService } from 'src/AgoraConfigService';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  httpHeaders: any;
  jsonTest: any;
  agoraConfigObject: any;

  constructor(private http: HttpClient, private agoraConfig: AgoraConfigService) {
		this.agoraConfigObject = this.agoraConfig.getConfig().endpoints;
    this.httpHeaders = new HttpHeaders().set('Content-Type', 'application/json;charset=utf-8').set("Access-Control-Allow-Origin", "*")
      .set("Access-Control-Allow-Headers", "*")
      .set("Access-Control-Allow-Methods", "GET,POST,PUT,DELETE");
  }
  searchMeetings(jsonReq: any) {
     return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}` + "searchMeetings", jsonReq, { headers: this.httpHeaders })
      .pipe(map((data) => {
        return data;
      }), catchError(error => {
        return throwError('Something went wrong!');
      })
      )
  };


  loadMeetingDetails(searchJSON: any) {
    // return this.http.post<any>(`${environment.meetingServiceURL}` + "searchMeetings", jsonReq, { headers: this.httpHeaders })
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}` + "meetingEvents", searchJSON, { headers: this.httpHeaders })
      .pipe(map((data) => {
        return data;
      }), catchError(error => {
        return throwError('Something went wrong!');
      })
      )
  }
  searchTasks(jsonReq: any) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.task}` + "taskSearch", jsonReq, { headers: this.httpHeaders })
      .pipe(map((data) => {
        return data;
      }), catchError(error => {
        return throwError('Something went wrong!');
      })
      )
  };
  toLinkMeetingSearch(jsonReq: any) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.search}` + "/linkMeetingSearch", jsonReq, { headers: this.httpHeaders ,observe: 'response'})
  }
}
